var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"friend-list"},[_c('v-content',[_c('v-row',{staticClass:"mt-0 mb-0 pt-0 pb-0"},[_c('Searchbar',{attrs:{"type":'user',"cols":12}})],1),_c('GameList',{attrs:{"headlines":_vm.friends,"voteable":false,"show-rating":true,"showUserRating":true,"type":"user","url":_vm.url}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }